import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SeoService } from '../../seo/seo.service';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'app-blog-articolo-pulizie-appartamento',
  imports: [CommonModule],
  templateUrl: './blog-articolo-pulizie-appartamento.html',
  styleUrls: ['./blog-articolo-pulizie-appartamento.scss'],
})
export class BlogArticoloPulizieAppartamentoComponent implements OnInit {
  constructor(private router: Router, private seo: SeoService) {}

  ngOnInit(): void {
    this.seo.updateTags({
      title: 'Quanto costano le pulizie di un appartamento a Pescara? | SAMI Pulizie',
      description:
        'Scopri quanto costano le pulizie di un appartamento a Pescara. Prezzi, fattori che incidono sul costo, metratura, frequenza e tipologia di servizio.',
      keywords:
        'costo pulizie appartamento Pescara, prezzi pulizie casa Pescara, impresa di pulizie Pescara, pulizie domestiche',
      canonicalUrl: '/blog/quanto-costano-pulizie-appartamento-pescara',

      ogTitle: 'Quanto costano le pulizie di un appartamento a Pescara?',
      ogDescription:
        'Prezzi e fattori che incidono sul costo delle pulizie di un appartamento a Pescara.',
      ogImage: '/assets/og-sami.jpg',
      ogType: 'article',

      jsonLd: {
        '@context': 'https://schema.org',
        '@type': 'Article',
        headline: 'Quanto costano le pulizie di un appartamento a Pescara?',
        datePublished: '2025-03-25',
        dateModified: '2025-03-25',
        author: {
          '@type': 'Organization',
          name: 'SAMI Pulizie',
          url: 'https://samipulizie.it/'
        },
        publisher: {
          '@type': 'Organization',
          name: 'SAMI Pulizie',
          logo: {
            '@type': 'ImageObject',
            url: 'https://samipulizie.it/assets/logo.png'
          }
        },
        mainEntityOfPage: {
          '@type': 'WebPage',
          '@id': 'https://samipulizie.it/blog/quanto-costano-pulizie-appartamento-pescara'
        }
      }
    });
  }

  navigateToPreventivo() {
    this.router.navigateByUrl('/preventivo');
  }
}
